//https://j11y.io/javascript/regex-selector-for-jquery/
(function ($) {
    $.extend($.expr[':'], {
        regex: function (elem, index, match) {
            var matchParams = match[3].split(','),
                validLabels = /^(data|css):/,
                attr = {
                    method: matchParams[0].match(validLabels) ?
                        matchParams[0].split(':')[0] : 'attr',
                    property: matchParams.shift().replace(validLabels, '')
                },
                regexFlags = 'ig',
                regex = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g, ''), regexFlags);
            return regex.test(jQuery(elem)[attr.method](attr.property));
        }
    });
})(jQuery);

$(function () {
    //Replace native date inputs with more flexible js version
    $('input[type="date"]').attr('type', 'text').prop('readonly', true).datepicker({
        format: 'yyyy-mm-dd',
        weekStart: 1,
        offset: 1,
        language: 'en-GB',
        autoHide: true,
        zIndex: 1050, // needs to be above modal 
        filter: function (date, view) {
            var maxDate = new Date($(this).attr('max'));
            var minDate = new Date($(this).attr('min'));
            var minDateMonth = new Date(minDate.getTime());
            minDateMonth.setDate(1);
            var minDateYear = new Date(minDateMonth.getTime());
            minDateYear.setMonth(0);
            var disableWeekends = $(this).data('weekends') === 'disabled';
            var disabledDatesString = $(this).data('disabled');
            var disabledDates = typeof disabledDatesString !== 'undefined' ? disabledDatesString.split(',') : [];
            var wednesdaysOnly = $(this).data('wednesdays');

            var utcDateString = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
            var utcDate = new Date(utcDateString);

            switch (view) {
                case 'day':
                    if (utcDate < minDate || utcDate > maxDate) {
                        //console.table(date, minDate, maxDate);
                        return false;
                    }
                    if (wednesdaysOnly) {
                        switch (utcDate.getDay()) {
                            case 3:
                                break;
                            default:
                                return false;
                        }
                    }
                    else if (disableWeekends) {
                        switch (utcDate.getDay()) {
                            case 0:
                            case 6:
                                return false;
                        }
                    }
                    if (disabledDates.length > 0) {
                        var returnVal = true;
                        $.each(disabledDates, function (index, value) {
                            var disabledDate = new Date(value);
                            if (utcDate.getFullYear() === disabledDate.getFullYear() && utcDate.getMonth() === disabledDate.getMonth() && utcDate.getDate() === disabledDate.getDate()) {
                                returnVal = false;
                                return false; //break
                            }
                        });
                        return returnVal;
                    }
                    break;
                case 'month':
                    if (utcDate < minDateMonth || utcDate > maxDate) {
                        return false;
                    }
                    break;
                case 'year':
                    if (utcDate < minDateYear || utcDate > maxDate) {
                        return false;
                    }
                    break;
            }
        },
        pick: function (e) {
            $(this).siblings('.display-date').text(e.date != null ? formatDateNicely(e.date) : '');
        }
    }).on('change', function () {
        //console.log($(this).attr('id'));
        //console.log($(this).val());
        $(this).datepicker('update');
        $(this).trigger({
            type: 'pick.datepicker',
            view: '',
            date: $(this).val() != '' ? new Date($(this).val()) : null
        });
    }).wrap('<div class="date-container"></div>').after(function () {
        return '<span class="display-date">' + ($(this).val() != '' ? formatDateNicely(new Date($(this).val())) : '') + '</span>';
    });
});

function createFunctionWithTimeout(callback, opt_timeout) {
    var called = false;
    function fn() {
        if (!called) {
            called = true;
            callback();
        }
    }
    setTimeout(fn, opt_timeout || 1000);
    return fn;
}

var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function formatDate(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1; //Months are zero-indexed
    if (month < 10) {
        month = '0' + month;
    }
    var day = date.getDate();
    if (day < 10) {
        day = '0' + day;
    }
    return year + '-' + month + '-' + day;
}

function formatDateNicely(date) {
    var year = date.getFullYear();
    var month = monthNames[date.getMonth()];
    var day = date.getDate();
    return ordinal_suffix_of(day) + ' ' + month + ' ' + year;
}

function formatDateNicelyWithoutYear(date) {
    var month = monthNames[date.getMonth()];
    var day = date.getDate();
    return ordinal_suffix_of(day) + ' ' + month;
}

function ordinal_suffix_of(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}